import PurchareRequestsScreen from "../../Screen/ERP/Compras/PurchaseRequestScreen";
// import ProductosScreen from "../../Screen/ERP/Global/Productos/ProductosScreen";
import ProductosMateriaPrimaScreen from "../../Screen/ERP/Global/Productos/ProductosMateriaPrimaScreen";
import InventarioMateriaPrimaScreen from "../../Screen/ERP/MateriaPrima/Inventario/InventarioMateriaPrimaScreen";
import LotesScreen from "../../Screen/ERP/MateriaPrima/Lotes/LotesScreen";
import IngresoBodegaScreen from "../../Screen/ERP/Suministros/Bodegas/IngresosBodega/IngresoBodegaScreen";
import RequisasMaterialesScreen from "../../Screen/ERP/Suministros/Bodegas/RequisasMateriales/RequisasMaterialesScreen";
import SalidasMaterialesScreen from "../../Screen/ERP/Suministros/Bodegas/SalidasMateriales/SalidasMaterialesScreen";


export const MateriaPrima = [
  {
    path: "MateriaPrima/Requisas",
    permiso: 72,
    element: <RequisasMaterialesScreen MateriaPrima={1}/>,
  },
  {
    path: "MateriaPrima/Lotes",
    permiso: 73,
    element: <LotesScreen />,
  },
  {
    path: "MateriaPrima/Productos",
    permiso: 74,
    element: <ProductosMateriaPrimaScreen IdType={34}/>,
  },
  {
    path: "MateriaPrima/LiberarRequisas",
    permiso: 75,
    element: <RequisasMaterialesScreen MateriaPrima={1} IdEstado={29} IdPermisoGeneral={6}/>,
  },
  {
    path: "MateriaPrima/Salidas",
    permiso: 77,
    element: <SalidasMaterialesScreen MateriaPrima = {1}/>,
  },
  {
    path: "MateriaPrima/Inventario",
    permiso: 78,
    element: <InventarioMateriaPrimaScreen/>,
  },
  {
    path: "MateriaPrima/Ingresos",
    permiso: 79,
    element: <IngresoBodegaScreen Bodega={false} MateriaPrima={true} Servicios ={false}/>
  },
  {
    path: "MateriaPrima/RequisasCompras",
    permiso: 110,
    element: <PurchareRequestsScreen MateriaPrima={true}/>,
  },

];
  
export default MateriaPrima;
  